import type {
  CreditMemoGetApiData,
  CreditMemoGetApiResponses,
  CreditMemoListApiData,
  CreditMemoListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint } from '../defineResource';

export const getCreditMemoUrls = {
  getPaginatedCreditMemos: dataEndpoint<CreditMemoListApiData, CreditMemoListApiResponses>({
    getUrl: (queryParams) => apiUrl('credit-memos/', queryParams)
  }),
  getCreditMemo: dataEndpoint<CreditMemoGetApiData, CreditMemoGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`credit-memos/${pk}/`)
  })
};
